import { API_URL, GETAPI } from "./config";


export const API_ANALITICS= async () => {
    const res = await GETAPI(API_URL.analitics);
    return res;
  };
  
